import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import SimuladorNumericInput from "./SimuladorNumericInput";
import BuildIcon from '@mui/icons-material/Build';
import ConstructionIcon from '@mui/icons-material/Construction';
import BathroomIcon from '@mui/icons-material/Bathroom';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { SimuladorIncentivosJefeTallerOR } from "./SimuladorIncentivosJefeTallerOR";
import StarIcon from '@mui/icons-material/Star';
import { SimuladorIncentivosJefeTallerEficiencioOR } from "./SimuladorIncentivosJefeTallerEficienciaOR";
import { SimuladorIncentivosJefeTallerORSE } from "./SimuladorIncentivosJefeTallerORSE";


const SimuladorIncentivosJefeTaller = ({ puesto }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        puesto: "",
        fecha: "",
        monto: "",
    });

    const [incentivoTotal, setIncentivoTotal] = useState(0);

    const [incentivoHoras, setIncentivoHoras] = useState(0);

    const [porcEficiencia, setPorcEficiencia] = useState(0);

    const [tecnicos150, setTecnicos150] = useState(0);

    const [tecnicosTotal, setTecnicosTotal] = useState(0);

    const [incentivoEficiencia, setIncentivoEficiencia] = useState(0);


    const [datos, setDatos] = useState({
        sueldo: 0,
        incentivo: 0,
        tecnicosMas150: "",
        totalTecnicos: "",
        porcentajeTecnicos: ""
    });


    const handleChangeDatos = (e) => {
        const { name, value } = e.target;
        setDatos({
            ...datos,
            [name]: value,
        });
    };

    // const handleSetTecnicosMas150 = (valor) => {
    //     setDatos((prev) => ({ ...prev, tecnicosMas150: valor }));
    // };
    // const handleSetTotalTecnicos = (valor) => {
    //     setDatos((prev) => ({ ...prev, totalTecnicos: valor }));
    // };

    useEffect(() => {
        // if (Number(tecnicos150) > 0 && Number(tecnicosTotal) > 0) {

        let porcentaje = 0;

        porcentaje = tecnicos150 / tecnicosTotal;

        setDatos({
            ...datos,
            porcentajeTecnicos: porcentaje * 100,
        });
        // }
    }, [tecnicosTotal, tecnicos150]);

    const rangoBajo = [
        { minimo: 0, maximo: 34.99, porcentaje: 0 },
        { minimo: 35, maximo: 44.99, porcentaje: 0.40 },
        { minimo: 45, maximo: 64.99, porcentaje: .45 },
        { minimo: 65, maximo: 79.99, porcentaje: .55 },
        { minimo: 80, maximo: 99.99, porcentaje: .60 },
        { minimo: 100, maximo: 150000, porcentaje: .65 },
    ]

    const rangoMedio = [
        { minimo: 0, maximo: 34.99, porcentaje: 0 },
        { minimo: 35, maximo: 44.99, porcentaje: 0.45 },
        { minimo: 45, maximo: 64.99, porcentaje: .50 },
        { minimo: 65, maximo: 79.99, porcentaje: .60 },
        { minimo: 80, maximo: 99.99, porcentaje: .65 },
        { minimo: 100, maximo: 150000, porcentaje: .70 },
    ]

    const rangoAlto = [
        { minimo: 0, maximo: 34.99, porcentaje: 0 },
        { minimo: 35, maximo: 44.99, porcentaje: 0.50 },
        { minimo: 45, maximo: 64.99, porcentaje: .55 },
        { minimo: 65, maximo: 79.99, porcentaje: .65 },
        { minimo: 80, maximo: 99.99, porcentaje: .70 },
        { minimo: 100, maximo: 150000, porcentaje: .75 },
    ]

    const cumplimientoVenta = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 84.99, porcentaje: 0.15 },
        { minimo: 85, maximo: 89.99, porcentaje: .20 },
        { minimo: 90, maximo: 94.99, porcentaje: .30 },
        { minimo: 95, maximo: 99.99, porcentaje: .35 },
        { minimo: 100, maximo: 150000, porcentaje: .40 },
    ]


    //SATISFACCION DEL CLIENTE
    const [satisfacción, setSatisfaccion] = useState({
        porcentaje: 0,
        incentivo: "",
    });

    const handleChangeSatisfaccion = (e) => {
        const { name, value } = e.target;
        setSatisfaccion({
            ...datos,
            [name]: value,
        });
    };

    const rangoSatisfaccion = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 84.99, porcentaje: 0.15 },
        { minimo: 85, maximo: 89.99, porcentaje: .20 },
        { minimo: 90, maximo: 94.99, porcentaje: .30 },
        { minimo: 95, maximo: 99.99, porcentaje: .35 },
        { minimo: 100, maximo: 150000, porcentaje: .40 },
    ]


    useEffect(() => {
        if (Number(satisfacción.porcentaje !== 0)) {
            let incentivo = 0;
            rangoSatisfaccion.forEach((index) => {
                if (index.minimo <= satisfacción.porcentaje && index.maximo >= satisfacción.porcentaje) {
                    incentivo =
                        Number(datos.sueldo) * index.porcentaje;
                }
            });

            setSatisfaccion({
                ...satisfacción,
                incentivo,
            });
        }
    }, [satisfacción.porcentaje, datos.sueldo]);

    //IncentivoTotal
    useEffect(() => {
        let incentivoTotal = 0;

        incentivoTotal =
            Number(incentivoHoras) + Number(incentivoEficiencia);

        setIncentivoTotal(incentivoTotal);
    }, [incentivoEficiencia, incentivoHoras]);

    
    return (
        <>
            <div className="simulador-incentivo-form-seccion">
                <div className="input-section-container-base-salary">
                    <div className="input-section">
                        <div className="input-section-label">
                            SALARIO BASE
                        </div>
                        <SimuladorNumericInput
                            name="sueldo"
                            label=""
                            value={datos.sueldo}
                            disabled={false}
                            onChange={handleChangeDatos}
                            icono="pesos"
                        />
                    </div>
                </div>

                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon /> Venta de Servicio
                    </div>
                    <SimuladorIncentivosJefeTallerORSE
                        rango={cumplimientoVenta}
                        sueldo={datos.sueldo}
                        setHoras={setIncentivoHoras}
                        setPorcEficiencia={setPorcEficiencia}
                        tecnicosMas150={datos.tecnicosMas150}
                        handleChangeDatos={handleChangeDatos}
                        totalTecnicos={datos.totalTecnicos}
                    />
                </div>

                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon /> Horas en Taller
                    </div>
                    <SimuladorIncentivosJefeTallerOR
                        rango={cumplimientoVenta}
                        sueldo={datos.sueldo}
                        setHoras={setIncentivoHoras}
                        setPorcEficiencia={setPorcEficiencia}
                        tecnicosMas150={datos.tecnicosMas150}
                        handleChangeDatos={handleChangeDatos}
                        totalTecnicos={datos.totalTecnicos}
                        ocultar={true}
                    />
                </div>



                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon /> Eficiencia de Taller
                    </div>
                    <SimuladorIncentivosJefeTallerEficiencioOR
                        rango={
                            datos.porcentajeTecnicos < 30
                                ? rangoBajo
                                : datos.porcentajeTecnicos < 60
                                    ? rangoMedio
                                    : rangoAlto
                        }
                        sueldo={datos.sueldo}
                        porcEficiencia={porcEficiencia}
                        setEficiencia={setIncentivoEficiencia}
                        tecnicosMas150={setTecnicos150}
                        handleChangeDatos={handleChangeDatos}
                        totalTecnicos={setTecnicosTotal}
                    />
                </div>

                {/* <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <StarIcon sx={{ fontSize: "18px" }} /> Satisfacción del cliente
                    </div>

                    <div className="simulador-incentivo-vendedor-f3">
                        <div className="input-section-container-numeric">
                            <div className="input-container-one">

                                <div className="input-section">
                                    <div className="input-section-label">% de satisfacción del cliente</div>
                                    <SimuladorNumericInput
                                        name="porcentaje"
                                        label=""
                                        value={satisfacción.porcentaje}
                                        disabled={false}
                                        onChange={handleChangeSatisfaccion}
                                        icono="porcentaje"
                                    />
                                </div>
                            </div>
                            <div className="input-container-one">
                                <div className="input-section">
                                    <div className="input-section-label">Tu incentivo es de:</div>
                                    <SimuladorNumericInput
                                        name="incentivo"
                                        value={satisfacción.incentivo}
                                        disabled
                                        inputTotal="si"
                                        icono="pesos"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div >
            <div className="simulador-incentivo-nuevoformat">
                <div className="simulador-incentivo-form-titulos">
                    <span>
                        Considerando los datos ingresados, tu Incentivo total simulado es:
                    </span>

                    <SimuladorNumericInput
                        name="Total"
                        label=""
                        value={incentivoTotal}
                        disabled={true}
                        icono="none"
                        align="centro"
                    />
                </div>
                <div className="simulador-incentivo-form-titulo-leyenda">
                    Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
                </div>
            </div>
        </>
    );
};

export default SimuladorIncentivosJefeTaller;
